export default __webpack_public_path__ + "static/media/dark-plus.1b86a092.svg";